<template>
  <div v-if="type==='notification'" class="short-card" :class="!request.seenAt? 'short-card-new':''" role="button" tabindex="0" @click="$emit('click', request)" @keydown.enter="$emit('click', request)">
    <span class="short-card__avatar-wrap">
      <span
        class="short-card__avatar"
        :style="{ background: avatarColor(request.type) }"
      >
        <span class="short-card__initials">{{ initials(request.type) }}</span>
      </span>
    </span>

    <span class="short-card__meta">
      <span class="short-card__name">{{ request.text }}</span>
      <span class="short-card__desc">{{ request.description+'...' }}</span>
    </span>
  </div>
  <div v-else class="short-card" role="button" tabindex="0" @click="$emit('click', request)" @keydown.enter="$emit('click', request)">
    <span class="short-card__avatar-wrap">
      <span
        class="short-card__avatar"
        :style="{ background: getUser(request.userId).profilImgMini1 ? `url(${bsrImg + getUser(request.userId).profilImgMini1}) no-repeat center / cover` : { background: avatarColor(request.userId) } }"
      >
        <span v-if="!request.img" class="short-card__initials">{{ initials(request.userId) }}</span>
      </span>
      <span v-if="live" class="short-card__live-dot" aria-label="Live"></span>
    </span>

    <span class="short-card__meta">
      <span class="short-card__name">{{ getUser(request.userId).pseudo }}</span>
      <span class="short-card__desc">{{ request.text?.slice(0,30)+'...' }}</span>
    </span>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { useStore } from 'vuex'

const store = useStore()

const bsrImg = store.state.baseUrl + "images/";
defineProps({
  request: {
    type: Object,
    required: true
    // expected: { userId, text, img }
  },
  live: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: null
  }
})

defineEmits(['click'])

const avatarPalette = [
  'linear-gradient(135deg,#38bdf8,#6366f1)',
  'linear-gradient(135deg,#ec4899,#8b5cf6)',
  'linear-gradient(135deg,#22d3ee,#0ea5e9)',
  'linear-gradient(135deg,#f97316,#ec4899)',
  'linear-gradient(135deg,#a78bfa,#38bdf8)'
]

function getUser(userId) {
  return store.state.users[userId] || {};
}

function hashString(str = '') {
  let h = 0
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i)
    h |= 0
  }
  return Math.abs(h)
}

function avatarColor(userId) {
  return avatarPalette[hashString(userId) % avatarPalette.length]
}

function initials(userId = '') {
  return userId.trim().slice(0, 2).toUpperCase()
}
</script>

<style scoped>
.short-card {
  --border: rgba(148, 163, 184, 0.1);
  --text-primary: #e7ebf5;
  --text-secondary: #8592ad;
  --live: #fb3d68;

  display: flex;
  align-items: center;
  padding: 9px 8px;
  border-radius: 12px;
  cursor: pointer;
  font-family: 'Inter', 'Sora', system-ui, -apple-system, sans-serif;
}

.short-card:hover,
.short-card:focus-visible {
  background: rgba(148, 163, 184, 0.06);
}
.short-card-new {
  background: rgba(148, 163, 184, 0.03);
}

.short-card:focus-visible {
  outline: 2px solid #22d3ee;
  outline-offset: -2px;
}

.short-card__avatar-wrap {
  position: relative;
  flex-shrink: 0;
  margin-right: 12px;
}

.short-card__avatar {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.short-card__initials {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.short-card__live-dot {
  position: absolute;
  right: -3px;
  bottom: -3px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: var(--live);
  border: 2.5px solid #10162a;
  box-shadow: 0 0 0 0 rgba(251, 61, 104, 0.6);
  animation: short-card-pulse 1.6s infinite;
}

@keyframes short-card-pulse {
  0% { box-shadow: 0 0 0 0 rgba(251, 61, 104, 0.55); }
  70% { box-shadow: 0 0 0 5px rgba(251, 61, 104, 0); }
  100% { box-shadow: 0 0 0 0 rgba(251, 61, 104, 0); }
}

.short-card__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.short-card__name {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.short-card__desc {
  margin-top: 2px;
  font-size: 12.5px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 340px) {
  .short-card__avatar { width: 40px; height: 40px; border-radius: 10px; }
  .short-card__initials { font-size: 13px; }
  .short-card__live-dot { width: 11px; height: 11px; }
  .short-card__name { font-size: 13px; }
  .short-card__desc { font-size: 11.5px; }
}
</style>